var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"on-clickaway",rawName:"v-on-clickaway",value:(_vm.abort),expression:"abort"}],staticClass:"confirm-button",class:{ 'is-warning' : _vm.confirm },on:{"click":_vm.click}},[(_vm.confirm)?_vm._t("confirm",[_vm._v("Confirm")]):_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db9d1b46","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/sba-confirm-button.vue
// module id = null
// module chunks = 